import React from 'react'
import { Link as LinkNav } from "react-router-dom";
import { UserContext } from '../../Context/UserContext';
import {
    Box,
    chakra,
    Container,
    Stack,
    Text,
    useColorModeValue,
    VisuallyHidden,
    Image, 
    Flex,
    Divider,
  } from '@chakra-ui/react';

  import { FaInstagram, FaGlobe } from 'react-icons/fa';
  import logo from '../../Assets/Png/logoFooter.png'
  import logoBlack from '../../Assets/Png/logoBlackFooter.png'

  const SocialButton = ({
    children,
    label,
    href,
  }) => {
    return (
      <chakra.button
        bg={useColorModeValue('blackAlpha.100', 'whiteAlpha.100')}
        rounded={'full'}
        w={9}
        h={9}
        cursor={'pointer'}
        as={'a'}
        href={href}
        display={'inline-flex'}
        alignItems={'center'}
        justifyContent={'center'}
        transition={'all 0.3s ease'}
        target="_blank" 
        _hover={{
          bg: 'brand.500',
          color: 'white',
          transform: 'translateY(-2px)',
          shadow: 'lg',
        }}>
        <VisuallyHidden>{label}</VisuallyHidden>
        {children}
      </chakra.button>
    );
  };
  
  export default function Footer() {
    const bgColor = useColorModeValue('whiteAlpha.800', 'blackAlpha.800')
    const borderColor = useColorModeValue('gray.100', 'whiteAlpha.100')
    const currentYear = new Date().getFullYear();

    return (
      <Box 
        bg={bgColor} 
        backdropFilter="blur(10px)" 
        borderTop="1px solid" 
        borderColor={borderColor}
        w='100%' 
        mt='auto'
      >
        <Container
          as={Stack}
          maxW={'1200px'}
          py={3}
          direction={{ base: 'column', md: 'row' }}
          spacing={4}
          justify={'space-between'}
          align={'center'}
        >
          <Flex align="center" gap={4}>
            <LinkNav to={'/'} >
              <Image 
                src={useColorModeValue(logoBlack, logo)} 
                h='5' 
                alt="SI Informática"
                transition="all 0.3s"
                _hover={{ opacity: 0.8 }}
              />
            </LinkNav >
            <Divider orientation="vertical" h="20px" hideFrom="md" />
            <Text 
              fontSize="xs" 
              color="gray.500" 
              fontWeight="medium"
              textAlign={{ base: 'center', md: 'left' }}
            >
              © {currentYear} SI Informática. Todos os direitos reservados.
            </Text>
          </Flex>

          <Stack direction={'row'} spacing={3}>
            <SocialButton label={'Instagram'} href={'https://www.instagram.com/si.informatica/'}>
              <FaInstagram />
            </SocialButton>
            <SocialButton label={'Site'} href={'https://www.siprogramas.com.br/'}>
              <FaGlobe />
            </SocialButton>
          </Stack>
        </Container>
      </Box>
    );
  }